/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:04:41
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-13 15:04:50
 * @FilePath: \crm-product\src\views\performanceCalculation\views\import_statement\product_price\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import peopleList from '../../product_price/form/product_list.vue';

formCreate.component('peopleList', peopleList);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {

    };
  },
  async created() {
    await this.getFormRule('main-form');
  },
  methods: {
    // 设置规则
    setRule(item) {
      const v = item;
      if (v.field === 'userName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'select-people-list',
            parentCode: 'CRM20260526000000009',
            paramData: {
              enableStatus: '009',
            },
          },
          title: '选择人员',
        };
        v.on = {
          ...v.on,
          change: (e) => {
            if (e && e.length) {
              const objProduct = e[0];
              this.setValue({
                userName: objProduct.userName,
                userCode: objProduct.userCode,
                orgCode: objProduct.orgCode,
                orgName: objProduct.orgName,
                userRole: objProduct.userRole,
                parentUserName: objProduct.superiorName,
                parentUserCode: objProduct.superiorCode,
                parentOrgCode: objProduct.superiorOrgCode,
                parentOrgName: objProduct.superiorOrgName,
                parentRole: objProduct.superiorRole,
                promotionOrgCode: objProduct.promotionOrgCode,
                promotionOrgName: objProduct.promotionOrgName,
              });
            }
          },
        };
      }
      if (v.field === 'monthTarget') {
        v.props = {
          ...v.props,
          min: 0,
          precision: 2,
        };
      }
      return v;
    },
    // 渲染完成后执行
    formComplete() {
      const {
        code,
      } = this.formConfig;
      if (code === 'view' || code === 'edit') {
        request.post('/mdm/performancesitetarget/query', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            const {
              result,
            } = res;
            this.setValue({
              ...result,
              statMonth: `${result.statMonth}`,
            });
          }
        });
      }
    },
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/mdm/performancesitetarget/save';
        const params = {
          ...formData,
          statMonth: Number(formData.statMonth),
        };
        if (this.formConfig.code === 'edit') {
          url = '/mdm/performancesitetarget/update';
          params.id = this.formConfig.row.id;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
